module.exports = __webpack_public_path__ + "static/media/06.ade1c999.jpg";